module.exports = __webpack_public_path__ + "RentGuaranteePayments-2akNZNG.svg";